export default "__VITE_ASSET__9cdac998__"